import styled from 'styled-components';

import { buildStyledComponent } from 'decisiv-ui-utils';
import { Row } from 'styled-components-reactive-grid';

const styles = `
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export default buildStyledComponent(
  'ScrollableContainer__Row',
  styled(Row),
  styles,
);



// WEBPACK FOOTER //
// ./src/blocks/ScrollableContainer/Row.js